import isApiError from "@insite/client-framework/Common/isApiError";
import { get } from "@insite/client-framework/Services/ApiService";
import { generateQueryString } from "@WhiteCap/Common/Utillities/utils";

export interface ApiResultModel {
    properties?: {
        [key: string]: string;
    };
    openQuotes?: QuoteModel[];
    pageNumber: number;
    pageSize: number;
    sortColumn?: string;
    sortDirection?: string;
    searchTerm?: string;
    uri?: string,
    status?: string,
    totalQuotes: number,
    jobsites?: string [],
    createdStartDate?: Date,
    createdEndDate?: Date,
}
export interface QuoteModel {
    quoteNumber: string;
    status: string;
    createdOn: string;
    expiresOn: string;
    items: string;
    total: number;
    totalDisplay: string;
    jobsite: string;
}

const url = "/api/v1/quotes/osn/getQuotes";

export async function getQuotesListService(
    pageNumber: number,
    pageSize: number,
    sortColumn?: string,
    sortDirection?: string,
    searchTerm?: string,
    jobsite?: string,
    quoteNumber?: string,
    createdStartDate?: string,
    createdEndDate?: string,
    expiredStartDate?: string,
    expiredEndDate?: string,
    customerNumber?: string,
) {
    const queryParams = generateQueryString({
        pageNumber,
        pageSize,
        sortColumn,
        sortDirection,
        searchTerm,
        jobsite,
        quoteNumber,
        createdStartDate,
        createdEndDate,
        expiredStartDate,
        expiredEndDate,
        customerNumber,
    });

    try {
        const result = await get<ApiResultModel>(`${url}?${queryParams}`, {}, {}, "no-store");
        return {
            successful: true,
            result,
        };
    } catch (error) {
        if (isApiError(error)) {
            return {
                successful: false,
                errorMessage: error.errorJson.message || "Something went wrong!",
            };
        }
        throw error;
    }
}

